<nb-card class="hours-overview">
  <nb-card-header>{{ 'hoursoverview.title' | translate }}: {{ projectName }}</nb-card-header>
  <nb-card-body>
    <form [formGroup]="form" class="period">
      <div>
        <label class="label">{{ 'hoursoverview.from' | translate }}</label>
        <input nbInput fieldSize="small" [nbDatepicker]="fromPicker" formControlName="from">
        <nb-datepicker #fromPicker format="DD-MM-YYYY"></nb-datepicker>
      </div>
      <div>
        <label class="label">{{ 'hoursoverview.to' | translate }}</label>
        <input nbInput fieldSize="small" [nbDatepicker]="toPicker" formControlName="to">
        <nb-datepicker #toPicker format="DD-MM-YYYY"></nb-datepicker>
      </div>
    </form>

    @if (!valid) {
      <p class="warning">{{ 'hoursoverview.invalidperiod' | translate }}</p>
    }
    @if (busy) {
      <p class="muted">{{ 'loading' | translate }}</p>
    }
    @if (failed) {
      <button type="button" nbButton size="tiny" ghost status="primary" (click)="load()">{{ 'retry' | translate }}</button>
    }
    @if (preview) {
      @if (preview.totals.length) {
        <table>
          <thead>
            <tr>
              <th>{{ 'hoursoverview.person' | translate }}</th>
              <th class="num">{{ 'hoursoverview.hours' | translate }}</th>
              <th class="num">{{ 'hoursoverview.rate' | translate }}</th>
              <th class="num">{{ 'hoursoverview.amount' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (t of preview.totals; track $index) {
              <tr>
                <td>{{ t.person }}</td>
                <td class="num">{{ t.hundredths / 100 | number:'1.2-2':lang }}</td>
                <td class="num">@if (t.rate_cents != null) { {{ t.rate_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }} } @else {<span class="warning">{{ 'hoursoverview.norate' | translate }}</span>}</td>
                <td class="num">@if (t.amount_cents != null) { {{ t.amount_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }} }</td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <td>{{ 'hoursoverview.total' | translate }}</td>
              <td class="num">{{ preview.hundredths / 100 | number:'1.2-2':lang }}</td>
              <td></td>
              <td class="num">@if (priced) { {{ preview.amount_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }} }</td>
            </tr>
          </tfoot>
        </table>
      } @else {
        <p class="muted">{{ 'hoursoverview.empty' | translate }}</p>
      }
      @if (preview.no_rate.length) {
        <p class="warning">{{ 'hoursoverview.norateWarning' | translate:{names: preview.no_rate.join(', ')} }}</p>
      }
      @if (hasKm) {
        <nb-checkbox class="include-km" [checked]="includeKm" (checkedChange)="includeKm = $event">{{ 'hoursoverview.includeKm' | translate }}</nb-checkbox>
        @if (includeKm) {
          <table>
            <thead>
              <tr>
                <th>{{ 'hoursoverview.person' | translate }}</th>
                <th class="num">{{ 'hoursoverview.km' | translate }}</th>
                <th class="num">{{ 'hoursoverview.kmprice' | translate }}</th>
                <th class="num">{{ 'hoursoverview.amount' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (t of preview.km.totals; track $index) {
                <tr>
                  <td>{{ t.person }}</td>
                  <td class="num">{{ t.hundredths / 100 | number:'1.1-1':lang }}</td>
                  <td class="num">@if (t.price_e4 != null) { {{ t.price_e4 / 10000 | currency:'EUR':'symbol':'1.2-4':lang }} } @else {<span class="warning">{{ 'hoursoverview.noprice' | translate }}</span>}</td>
                  <td class="num">@if (t.amount_cents != null) { {{ t.amount_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }} }</td>
                </tr>
              }
            </tbody>
            <tfoot>
              <tr>
                <td>{{ 'hoursoverview.kmtotal' | translate }}</td>
                <td class="num">{{ preview.km.hundredths / 100 | number:'1.1-1':lang }}</td>
                <td></td>
                <td class="num">{{ preview.km.amount_cents / 100 | currency:'EUR':'symbol':'1.2-2':lang }}</td>
              </tr>
              @if (!blocked) {
                <tr class="grand">
                  <td colspan="3">{{ 'hoursoverview.grandtotal' | translate }}</td>
                  <td class="num">{{ (preview.amount_cents + preview.km.amount_cents) / 100 | currency:'EUR':'symbol':'1.2-2':lang }}</td>
                </tr>
              }
            </tfoot>
          </table>
          @if (preview.km.no_price.length) {
            <p class="warning">{{ 'hoursoverview.nopriceWarning' | translate:{names: preview.km.no_price.join(', ')} }}</p>
          }
        }
      }
      @if (preview.orphan_hundredths > 0) {
        <p class="warning">{{ 'hoursoverview.orphanWarning' | translate:{hours: (preview.orphan_hundredths / 100 | number:'1.2-2':lang)} }}</p>
      }
    }
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost size="small" (click)="close()">{{ 'close' | translate }}</button>
    <button nbButton status="primary" size="small" [disabled]="!valid || downloading || blocked" (click)="download()">
      <nb-icon icon="download-outline"></nb-icon>
      {{ 'hoursoverview.download' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
